// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__HrubL","top":"Sidebar_top__FibDj","logo":"Sidebar_logo__CVN78","active":"Sidebar_active__AF0gR","logout":"Sidebar_logout__43W0n"};